import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export function originInterceptorFn(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  req = req.clone({
    headers: req.headers.set('ninety-origin', location.origin).set('ninety-context', 'mobile'),
  });

  return next(req);
}
